import axios from "axios";

// API d'authentification / données (Express + MySQL)
// timeout : évite qu'une requête qui ne se résout pas (réseau/proxy) fasse tourner
// un spinner à l'infini. 75s couvre le provisioning AzuraCast (jusqu'à 60s) + marge.
const api = axios.create({
  baseURL: process.env.REACT_APP_AUTH_URL || "http://localhost:5000",
  timeout: 75000,
});

// Joindre automatiquement le token JWT à chaque requête
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
